module.exports = __webpack_public_path__ + "static/media/family_22.82a96cd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_22.jpg
// module id = 5853
// module chunks = 0